export default {
  data() {
    return {
      shouldListGoUp: false,
    };
  },
  methods: {
    setDirection(containerRef, itemRef) {
      const refBottomPosition = containerRef.getBoundingClientRect().bottom;
      const viewportHeight = window.innerHeight;
      const remainingHeightToViewportBottom = viewportHeight - refBottomPosition;

      this.$nextTick(() => {
        const refHeight = itemRef.clientHeight;
        this.shouldListGoUp = refHeight > remainingHeightToViewportBottom;
      });
    },
  },
  computed: {
    upOrDownClass() {
      return {
        up: this.shouldListGoUp,
        down: !this.shouldListGoUp,
      };
    },
  },
};
